/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
// component
import Navbar from '../../components/navbar/index.vue';
import Swiper from './swiper/index.vue';
import ProductService from './product-service/index.vue';
import newsCenter from './news-center/index.vue';
// import codePayModel from '../../components/model/index.vue';
import AboutUs from './about-us/index.vue';
import managementTeam from './management-team/index.vue';
import mediaReports from './media-reports/index.vue';
import CooperativePartner from './cooperative-partner/index.vue';
import contactUs from './contact-us/index.vue';

// window.onscroll=function(){
//   var sl=-Math.max(document.body.scrollLeft, document.documentElement.scrollLeft);
//   document.getElementById('fixed').style.left= sl+'px';
// };

export default {
  name: 'home',
  components: {
    Navbar,
    Swiper,
    ProductService,
    newsCenter,
    // codePayModel,
    AboutUs,
    managementTeam,
    mediaReports,
    CooperativePartner,
    contactUs
  },
  data() {
    return {
    };
  },
  methods: {
  }
};
